import { Transaction } from '@codemirror/state'

import { CODE_EVENTS } from './telemetryEvents'

// Verbatim port of getTelemetryEventType from
// component/workspace/components/CodeEditor.jsx — same CodeMirror userEvent
// mapping, so CODE_* names mean the same thing in both deployments.
export const getTelemetryEventType = (cmEventType, changeText = '') => {
  if (cmEventType === 'input') {
    if (changeText === '\t' || changeText === '    ') return CODE_EVENTS.INDENT
    return CODE_EVENTS.TYPE
  }

  // Catch all input.type variants including compose
  if (cmEventType.startsWith('input.type')) return CODE_EVENTS.TYPE

  switch (cmEventType) {
    case 'input.paste': return CODE_EVENTS.PASTE
    case 'input.indent': return CODE_EVENTS.INDENT
    case 'delete.backward': return CODE_EVENTS.DELETE
    case 'delete.forward': return CODE_EVENTS.DELETE
    case 'delete.selection': return CODE_EVENTS.DELETE_SELECTION
    case 'delete.cut': return CODE_EVENTS.CUT
    case 'undo': return CODE_EVENTS.UNDO
    case 'redo': return CODE_EVENTS.REDO
    default: return CODE_EVENTS.UNKNOWN
  }
}

// Turn a CodeMirror ViewUpdate into the workspace's { name, payload } pair.
// The workspace reads this off a raw EditorView.updateListener; @uiw/react-codemirror
// hands the same ViewUpdate to onChange as its second argument, so the extraction
// (userEvent annotation → intent, iterChanges → exact diff) is identical.
export const describeDocChange = (update, newCode) => {
  // 1. Get user's intent
  let rawEventType = 'unknown'
  for (const tr of update.transactions) {
    const event = tr.annotation(Transaction.userEvent)
    if (event) {
      rawEventType = event
      break
    }
  }

  // 2. Extract Exact Text Changes (The "Diff")
  const changeDetails = []
  update.changes.iterChanges((fromA, toA, _fromB, _toB, inserted) => {
    changeDetails.push({
      from: fromA,
      to: toA,
      text: inserted.toString()
    })
  })

  // 3. Get first change text for event type detection
  const firstChangeText = changeDetails[0]?.text || ''

  return {
    name: getTelemetryEventType(rawEventType, firstChangeText),
    payload: {
      raw_action: rawEventType,
      changes: changeDetails,
      code: newCode,
      timestamp: Date.now()
    }
  }
}
